import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useProdutoUsuarioService() {
    const { authenticatedFetch } = useApi();

    // 🔍 Lista os produtos de um usuário
    const listarProdutosPorUsuario = async (idUser) => {
        const response = await authenticatedFetch(URLS.READ_BY_USER_ID_PRODUTO_USUARIO, {
            method: 'POST',
            body: JSON.stringify({ idUser }),
        });

        return response.json();
    };

    // ➕ Assina um produto para um usuário
    const assinarProduto = async (idUser, idProduto) => {
        const response = await authenticatedFetch(URLS.ASSINA_PRODUTO, {
            method: 'POST',
            body: JSON.stringify({
                idUser,
                idProduto,
            }),
        });

        return response.json();
    };

    // ❌ Cancela (deleta) a assinatura de um produto para um usuário
    const deletarAssinaturaProduto = async (idUser, idProduto) => {
        const response = await authenticatedFetch(URLS.ASSINA_PRODUTO_DELETE, {
            method: 'POST',
            body: JSON.stringify({
                idUser,
                idProduto,
            }),
        });

        return response.json();
    };

    return {
        listarProdutosPorUsuario,
        assinarProduto,
        deletarAssinaturaProduto,
    };
}